import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    connect() {
        this.raf = true;

        window.requestAnimationFrame(this._raf.bind(this));
    }

    disconnect() {
        this.raf = false;
        this.element.removeAttribute('style');
    }

    _raf() {
        this.element.removeAttribute('style');

        const elementStyle = window.getComputedStyle(this.element);

        if ('fixed' !== elementStyle.position) {
            return;
        }

        const footer = document.getElementById('footer');

        if (footer) {
            const footerTop = footer.getBoundingClientRect().top;
            const elementBottom = this.element.getBoundingClientRect().bottom;
            const elementOffset = parseInt(elementStyle.bottom);
            const offset = Math.max(0, (elementBottom + elementOffset) - footerTop);

            if (offset > 0) {
                this.element.style.bottom = `${offset + elementOffset}px`;
            }
        }

        if (this.raf) {
            window.requestAnimationFrame(this._raf.bind(this));
        }
    }
}
